import React from "react";

const BillingPage = () => {
  return <div>BillingPage</div>;
};

export default BillingPage;
